import React from 'react';
import { TextInput, TextInputProps } from './textfield';

export function BsbNumberInput(props: TextInputProps) {
  return (
    <TextInput
      {...props}
      maxLength={6}
      rules={[
        {
          pattern: /^[0-9]*$/,
          message: 'Provide only numbers',
        },
        {
          len: 6,
          message: 'Provide 6 digits',
        },
      ]}
    />
  );
}
